var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.source)?_c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('h5',[_vm._v("A Carregar")]),_c('sub')]):_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticClass:"pdf",attrs:{"src":_vm.source,"page":i}})})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }